import { makeAutoObservable } from 'mobx';
import _ from 'lodash';

class DropdownFilterState {
  filterUpdated;
  attr;
  filter;
  options;

  constructor({attr, filter, filterUpdated, defaultFilter = 0, defaultFilterPropagated, options}) {
    makeAutoObservable(this);

    this.filterUpdated = filterUpdated;
    this.attr = attr;
    this.filter = filter;
    this.options = options;

    if (!this.filter.has(this.attr)) {
      this.filter.set(this.attr, options[defaultFilter].id);
    }

    defaultFilterPropagated({
      [this.attr]: options[defaultFilter].id
    });
  }

  changeOption(option) {
    this.filterUpdated({
      [this.attr]: option.id
    });
  }

  get selected() {
    return _.find(this.options, {id: this.filter.get(this.attr)});
  }
}

export default DropdownFilterState;
